import { computed, inject, Injectable } from '@angular/core';

import { AbilityFacade } from '@core/abilities-legacy';
import { Ability } from '@core/abilities-types';
import { injectDevFlag } from '@core/dev-flags-logic';
import { DevFlag } from '@core/dev-flags-types';
import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { FeatureCode } from '@core/feature-spec-types';

@Injectable({ providedIn: 'root' })
export class HireAssistantAccessService {
  private readonly featureSpecFacade = inject(FeatureSpecFacade);
  private readonly abilityFacade = inject(AbilityFacade);

  private readonly hasAiCandidateMatchingFlag = injectDevFlag(DevFlag.AiCandidateMatching);

  public isAiScreeningEnabled = this.featureSpecFacade.selectIsEnabled(
    FeatureCode.AiCandidateScreening,
  );
  public isAiMatchingEnabled = this.featureSpecFacade.selectIsEnabled(
    FeatureCode.AiCandidateMatching,
  );

  public hasHireAssistant = computed(
    () =>
      this.hasAiCandidateMatchingFlag &&
      (this.isAiScreeningEnabled() || this.isAiMatchingEnabled()),
  );

  public canManageMatchingCandidates = this.abilityFacade.checkAbility(
    Ability.ManageMatchingCandidates,
  );
}
